var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "rootVM" } }, [
      _c("i", { staticClass: "fa fa-spinner fa-spin" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }